// extracted by mini-css-extract-plugin
export default {"defaultInputGroup":"Checkbox-module__defaultInputGroup___d9EfA Form-module__inputGroup___9drlI","defaultLabel":"Checkbox-module__defaultLabel___lcBlK Form-module__label___OlbqA"};